// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36HQG","input":"styles_input__3FXN1"};